import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: '',
  content: `
Die Arbeitswelt verändert sich rasant. Märkte werden unübersichtlicher, Entscheidungen müssen schneller getroffen werden und Teams arbeiten häufig unter hoher Unsicherheit.

In der Managementliteratur wird diese Entwicklung manchmal mit dem Begriff VUCA beschrieben: eine Welt, die volatil, unsicher, komplex und schwer vorhersehbar ist.

Gerade in solchen Situationen sind Führungskräfte gefragt, die nicht nur schnell entscheiden, sondern auch Zusammenhänge erkennen, Stimmungen im Team wahrnehmen und langfristige Folgen bedenken.

Eine oft unterschätzte Stärke kann dabei Hochsensibilität sein. Einen vertiefenden Überblick zu den <a href="https://hochsensible-fuehrung.joerg-hoermann.de/haeufige-fragen" rel="noopener">häufigsten Fragen rund um Hochsensibilität und Führung</a> finden Sie ebenfalls auf meiner Seite.
  `
};
